import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api, addTicketsToShopBasket, getEventById, getEventInfosByEventId, getTicketTypesByEventId, getTicketTypeInfosByTicketTypeId, getTicketTypeNumberOfAvailableTickets, getZonesBySeatMapId, getLocationInfos } from "ticketino-api-client";
import axios from "axios";
import { motion } from "framer-motion";

import Header from "./components/Header";
import Loading from "./components/Loading";

import Zone from './components/Seatmap/Zone';

import "../css/seatmap.css";

const Home = () => {

    const [order, setOrder] = useState({});
    const [orderId, setOrderId] = useState();
    const [posId, setPosId] = useState();
    const [event, setEvent] = useState({});

    const [ticketTypes, setTicketTypes] = useState([]);

    const [moreInfo, setMoreInfo] = useState({});

    const [disabled, setDisabled] = useState(true);
    const [loaded, setLoaded] = useState(false);
    const [promotioncode, setPromotioncode] = useState("");
    const [promotioncodeAdded, setPromotioncodeAdded] = useState("");
    const [promotionError, setPromotionError] = useState("");
    const [unlockedTicketTypes, setUnlockedTicketTypes] = useState([]);
    const [isTicketTypesUnlocked, setIsTicketTypesUnlocked] = useState(false);
    const [eventIdWorkshopsSaturday, setEventIdWorkshopsSaturday] = useState([]);
    const [selectedSeats, setSelectedSeats] = useState([]);
    const [zones, setZones] = useState({});
    const [selectedZone, setSelectedZone] = useState();
    const [errorMessage, setErrorMessage] = useState();

    const [EventId, setEventId] = useState("");
    const [eventName, setEventName] = useState("");
    const [eventDate, setEventDate] = useState("");
    const [eventStartTime, setEventStartTime] = useState("");
    const [eventCity, setEventCity] = useState("");
    const [eventLocation, setEventLocation] = useState("");

    const [showMobileBasket, setShowMobileBasket] = useState(false);

    const [accordionTicketCategoryOpen, setAccordionTicketCategoryOpen] = useState(true);

    //without seatmap
    const [selectedTicketTypes] = useState([]);

    // react hook for navigation
    let navigate = useNavigate();

    // base url
    let baseUrl = process.env.REACT_APP_BASEURL_API;

    // setting the base url of the npm package api calls
    api.defaults.baseURL = baseUrl;

    // fetching resources
    const [resources, setResources] = useState({});

    // fetching params
    let { language, eventId } = useParams();

    let languageId = 0;

    // changing languageId according to the url
    switch (language) {
        case ("de" || "DE"):
            languageId = 1;
            break;
        case ("en" || "EN"):
            languageId = 3;
            break;
        default:
            languageId = 0;
            language = "de";
            break;
    }

    useEffect(() => {
        loadToken();

        // clear the addedPromocodes in the session
        let array = [];
        localStorage.setItem("AddedPromotions", JSON.stringify(array));
    }, []); //only on first page load

    useEffect(() => {
        requestResources();
    }, [language]); //everytime language is changed

    useEffect(() => {
        if (orderId) {
            loadEvent(eventId, orderId)
        }
    }, [orderId]); //gets called when an order is started

    useEffect(() => {
        if (event.info) {
            const formattedDate = formatEventDate(event.start, language);
            const startTimeFormatted = formatStartTime(event.start, language);

            localStorage.setItem("EventId", event.id);
            localStorage.setItem("EventName", event.info.name);
            localStorage.setItem("EventDate", formattedDate);
            localStorage.setItem("EventStartTime", startTimeFormatted);

            setEventId(event.id);
            setEventName(event.info.name);
            setEventDate(formattedDate);
            setEventStartTime(startTimeFormatted);
        }
    }, [event.info]);

    useEffect(() => {
        if (event.locationInfo) {

            localStorage.setItem("EventCity", event.locationInfo.city);
            localStorage.setItem("EventLocation", event.locationInfo.name);

            setEventCity(event.locationInfo.city)
            setEventLocation(event.locationInfo.name)
        }
    }, [event.locationInfo]);

    useEffect(() => {
        if (event.zoneMapId > 0) {
            requestSeatmapAndZones();
        }
    }, [event.zoneMapId]);

    const loadToken = async () => {
        await axios.get("form/token").then((res) => {
            axios.defaults.headers.common["Authorization"] = "Bearer " + res.data;
            api.defaults.headers.common['Authorization'] = "Bearer " + res.data;

            localStorage.setItem("token", res.data);

            requestFormSettings();
        });
    };

    useEffect(() => {
        if (!selectedSeats.length > 0) {
            setShowMobileBasket(false);
        }
    }, [selectedSeats]);


    const requestFormSettings = async () => {
        await axios.get(`form/formsettings`).then(async (res) => {
            setPosId(res.data.posId);
            setEventIdWorkshopsSaturday(res.data.eventIdWorkshopsSaturday);

            let currentOrderId = localStorage.getItem("orderId");

            if (currentOrderId > 0) {
                // Try to load the order, if not found, start a new one
                const loaded = await loadOrder(currentOrderId);
                if (!loaded) {
                    await startOrder(res.data.posId, eventId);
                }
            } else {
                await startOrder(res.data.posId, eventId);
            }
        });
    };

    const requestResources = async () => {
        await axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data?.translation);
            })
            .catch((error) => console.error(error.response.data));
    };

    const loadOrder = async (orderId) => {
        try {
            const updatedOrder = await getOrderByOrderId(orderId);
            if (!updatedOrder || updatedOrder === "" || updatedOrder === null) {
                localStorage.removeItem("orderId");
                setOrder({});
                return false;
            }
            setOrder(updatedOrder);
            setOrderId(orderId); // Set orderId here if order is valid
            return true;
        }
        catch (error) {
            if (error?.response?.status === 404) {
                localStorage.removeItem("orderId");
                setOrder({});
                return false;
            }
            console.error(error);
            return false;
        }
    }

    const getOrderByOrderId = async (orderId) => {
        try {
            const res = await axios.get(`${baseUrl}/ShopBasket/Order/${orderId}`);
            return res.data;
        }
        catch (error) {
            console.error(error);
        }
    }

    const startOrder = async (posId, eventId) => {
        let order = {
            affiliateShopId: null,
            currency: "CHF",
            tenantId: 1,
            languageId: languageId,
            pointOfSaleId: posId,
            abbreviation: "",
            paymentType: 1,
        };

        await axios
            .post(`${baseUrl}/ShopBasket/Order`, order)
            .then((res) => {
                localStorage.setItem("orderId", res.data.id);
                setOrderId(res.data.id);
                setLoaded(true);
            })
            .catch((error) => console.error(error.response.data));
    };

    const loadEvent = async (eventId, orderId) => {
        try {
            setLoaded(false);

            // Event
            const event = await getEventById(eventId);
            const infos = await getEventInfosByEventId(eventId);
            const LocationInfos = await getLocationInfos(event.locationId);

            // sorting it according to the language
            const eventInfo = infos.eventInfos.find(info => info.languageId == languageId) ?? infos.eventInfos[0];

            const locationInfo = LocationInfos.find(info => info.languageId == languageId) ?? LocationInfos[0];

            // setting the eventInfo object in the info attribute of event
            const updatedEventInfo = { ...event, info: eventInfo, locationInfo: locationInfo };

            // TicketType
            const ticketTypes = await getTicketTypesByEventId(eventId);

            const updatedTicketTypes = await Promise.all(
                ticketTypes.map(async (ticketType) => {
                    const info = await getTicketTypeInfosByTicketTypeId(ticketType.id);

                    // sorting it according to the language
                    const ticketTypeInfo = info.find(info => info.languageId == languageId) ?? info[0];

                    const ticketTypeAvailability = await getTicketTypeNumberOfAvailableTickets(ticketType.id, orderId);

                    // setting the ticketTypeInfo and ticketTypeAvailability object as attributes in ticketType (info and availability)
                    return { ...ticketType, info: ticketTypeInfo, availability: ticketTypeAvailability }
                })
            )

            // setting the values in the end
            setEvent(updatedEventInfo);
            setTicketTypes(updatedTicketTypes);
            setLoaded(true);

        } catch (error) {
            console.error(error);
        }
    }

    const formatEventDate = (dateString, locale = 'de') => {
        const date = new Date(dateString);

        const formatter = new Intl.DateTimeFormat(locale, {
            weekday: 'short',
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        });

        const parts = formatter.formatToParts(date);

        const weekday = parts.find(p => p.type === 'weekday')?.value.toUpperCase().replace('.', '');
        const day = parts.find(p => p.type === 'day')?.value;
        const month = parts.find(p => p.type === 'month')?.value;
        const year = parts.find(p => p.type === 'year')?.value;

        return `${weekday}, ${day}.${month}.${year}`;
    };

    const formatStartTime = (dateString, locale = 'de') => {
        const date = new Date(dateString);

        if (locale === 'de') {
            // German: 24-hour format with "UHR"
            const hours = date.getHours().toString().padStart(2, '0');
            const minutes = date.getMinutes().toString().padStart(2, '0');
            return `${hours}:${minutes} UHR`;
        } else if (locale === 'fr') {
            // French: 24-hour format, no "UHR"
            const hours = date.getHours().toString().padStart(2, '0');
            const minutes = date.getMinutes().toString().padStart(2, '0');
            return `${hours}:${minutes}`;
        } else {
            // English: 12-hour format with AM/PM
            return date.toLocaleTimeString(locale, {
                hour: 'numeric',
                minute: '2-digit',
                hour12: true,
            });
        }
    };

    const requestSeatmapAndZones = async () => {
        var zones = await getZonesBySeatMapId(event.zoneMapId);
        setZones(zones);
        //setSelectedZone({});
        if (zones?.length > 0) {
            setSelectedZone(zones[0]);
        }
    };

    const onSeatClick = (event, seat, alreadySelected) => {

        if (alreadySelected) {

            var selectedSeatList = selectedSeats.filter(s => s.id !== seat.id);
            setSelectedSeats(selectedSeatList);
        }
        else {
            const isAlreadyInList = selectedSeats.some(s => s.id === seat.id);
            if (!isAlreadyInList) {

                let selectedSeatList = [...selectedSeats, seat];
                setSelectedSeats(selectedSeatList);
            }
        }
    }
    const handleRemoveSeat = (seatId) => {

        let selectedSeatList = selectedSeats.filter(seat => seat.id !== seatId);

        setSelectedSeats(selectedSeatList);
    };

    const selectTicketTypeForSeat = (seatId, ticketTypeId) => {
        const updatedSeats = selectedSeats.map(seat => {

            if (seat.id === seatId) {
                return { ...seat, selectedTicketTypeId: ticketTypeId };
            }
            return seat;
        });

        setSelectedSeats(updatedSeats); // Assuming you're using useState

    }

    const applyPromotionCodeToOrder = async (orderId, code) => {
        try {
            const response = await axios.put(`${baseUrl}/ShopBasket/Order/${orderId}/PromotionCode/${code}`);
            return response.data;
        } catch (error) {
            console.error(error.response.data);
            setPromotionError(resources?.PromotionError);
        }
    }

    const deletePromotionCodeFromOrder = async (orderId, code) => {
        try {
            const response = await axios.delete(`${baseUrl}/ShopBasket/Order/${orderId}/PromotionCode/${code}`);
            return response.data;
        } catch (error) {
            console.error(error.response.data);
            setPromotionError(resources?.PromotionError);
        }
    }

    const getTicketTypeAvailability = async (ticketTypeId, orderId, promotionCode) => {
        try {
            const response = await axios.get(`${baseUrl}/TicketType/${ticketTypeId}/Availability?orderId=${orderId}&promotionCode=${promotionCode}`);
            return response.data;
        } catch (error) {
            console.error(error.response.data);
            setPromotionError(resources?.PromotionError);
        }
    }

    const addPromotionToOrder = async () => {
        setPromotionError("");
        setLoaded(false);

        const updatedUnlockedTicketTypes = await applyPromotionCodeToOrder(orderId, promotioncode);
        let updatedTicketTypes = [];

        updatedTicketTypes = await Promise.all(ticketTypes.map(async (ticketType) => {
            if (updatedUnlockedTicketTypes?.unlockedTicketTypes?.includes(ticketType.id)) {
                const unlockedTicketTypeAvailability = await getTicketTypeAvailability(ticketType.id, orderId, promotioncode);
                ticketType.availability = unlockedTicketTypeAvailability;
            }
            return ticketType;
        }))

        localStorage.setItem("addedPromotion", promotioncode);
        setPromotioncodeAdded(promotioncode);

        setTicketTypes(updatedTicketTypes)
        setUnlockedTicketTypes(updatedUnlockedTicketTypes?.unlockedTicketTypes ?? []);
        setIsTicketTypesUnlocked(true);
        setLoaded(true);
    }

    const removePromotionFromOrder = async () => {
        setPromotionError("");
        setLoaded(false);

        await deletePromotionCodeFromOrder(orderId, promotioncode);
        await loadEvent(eventId, orderId);

        setUnlockedTicketTypes([]);
        setIsTicketTypesUnlocked(false);
        setLoaded(true);
    }

    const addTicketToBasket = async () => {
        const hasSeatMap = !!event.zoneMapId;

        let ticketsToAdd = [];

        if (hasSeatMap) {
            if (selectedSeats.length === 0) return;

            // Validate selected seats
            const invalidSelection = selectedSeats.some(seat =>
                !seat.selectedTicketTypeId || seat.selectedTicketTypeId === 0
            );
            if (invalidSelection) return;

            ticketsToAdd = selectedSeats.map(seat => {
                const ticket = {
                    ticketTypeId: seat.selectedTicketTypeId,
                    seatId: seat.id,
                    quantity: 1,
                    zoneId: seat.ZoneId,
                };

                if (unlockedTicketTypes?.includes(seat.selectedTicketTypeId)) {
                    ticket.promotionCode = promotioncodeAdded;
                }

                return ticket;
            });
        } else {
            ticketsToAdd = selectedTicketTypes
                .filter(t => t.quantity !== "0")
                .map(t => {
                    if (unlockedTicketTypes.includes(t.ticketTypeId)) {
                        t.promotionCode = promotioncodeAdded;
                    }
                    return t;
                });
        }

        try {
            await axios.post(`${baseUrl}/ShopBasket/Order/${orderId}/Tickets`, {
                ticketsToAdd,
            });

            //// gtm - addToCart
            //window.dataLayer = window.dataLayer || [];
            //window.dataLayer.push({ event: 'addToCart' });

            navigate(`/${language}/shipping`);
        } catch (error) {
            console.error(error?.response?.data || error);
        }
    };

    const onSubmit = async () => {
        await addTicketToBasket();
    };

    const selectedSeatsDiv = () => {
        return (<div className="">
            <div className="d-flex align-items-center justify-content-between flex-wrap">
                <h3 className="mb-3 mt-3">{resources?.SeatmapYourSeats}</h3>
                <button
                    className="visible-mobile btn-choosemoretickets me-3"
                    onClick={handleHideMobileBasket}
                >
                    Weitere Sitze wählen
                </button>
            </div>
            {
                selectedSeats.map((seat, index) => (
                    <div className="mt-2" key={seat.id}>

                        <div class="text-uppercase">
                            <div className="row">
                                <div className="col-4">
                                    {resources?.SeatmapZone}
                                </div>
                                <div className="col-6">
                                    {seat.zoneName}
                                </div>
                                <div className="col-2 text-end">
                                    <button
                                        type="button"
                                        className="btn-close me-2"
                                        aria-label="Close"
                                        onClick={() => handleRemoveSeat(seat.id)}
                                    ></button>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col">
                                    <div className="row">
                                        <div className="col-4">{resources?.SeatmapRow}</div>
                                        <div className="col-8">{seat.rowName}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <div className="row">
                                        <div className="col-4">{resources?.SeatmapSeat}</div>
                                        <div className="col-8"> {seat.seatName}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <div className="row">
                                        {!isNaN(parseInt(seat.selectedTicketTypeId, 10)) ? (
                                            <>
                                                <div className="col-4">{resources?.SeatmapTicketPrice}</div>
                                                <div className="col-8">
                                                    {(() => {
                                                        const ticket = ticketTypes.find(tt => tt.id === parseInt(seat.selectedTicketTypeId, 10));
                                                        return ticket ? `${ticket.currency} ${ticket.price.toFixed(2)}` : '';
                                                    })()}
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <div className="col-4">&nbsp;</div>
                                                <div className="col-8">&nbsp;</div>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div className="row">
                            <div className="col me-2">
                                <select
                                    className="form-select form-select-seatmaptickets bg-white mt-4"
                                    aria-label=""
                                    value={seat.selectedTicketTypeId}
                                    onChange={(e) => {
                                        const selectedTicketTypeId = e.currentTarget.value;
                                        selectTicketTypeForSeat(seat.id, selectedTicketTypeId);
                                    }}
                                >
                                    <option key="default" value="">
                                        {resources?.SeatmapSelectCategory}
                                    </option>

                                    {seat.seatTicketTypes.map(tt => (
                                        <option key={tt.id} value={tt.id}>
                                            {tt.info?.name || "No name"}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        {/* White horizontal line between entries */}
                        {index !== selectedSeats.length - 1 && (
                            <hr style={{ borderBottom: "1px solid white", margin: "1rem 0" }} />
                        )}
                    </div>
                ))
            }
        </div >);
    }

    const mapTicketTypeNamesAndColors = () => {
        let ticketTypesSorted = [];

        if (ticketTypes && ticketTypes.length > 0) {
            ticketTypesSorted = [...ticketTypes].sort((a, b) => a.sortOrder - b.sortOrder);
        }

        return (
            <div
                style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '1rem' // spacing between items 
                }}
            >
                {ticketTypesSorted.map((tt) => (
                    <div
                        key={tt.id || tt.info?.name}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            width: '170px'  // fixed width for alignment 
                        }}
                    >
                        <div className="tickettype-circle" style={{ backgroundColor: tt.colorCode }}></div>
                        <div className="d-flex flex-column mb-1 ms-3">
                            <label className="text-black">{tt.info?.name}</label>
                            <label className="text-black">{tt.currency} {tt.price.toFixed(2)}</label>
                        </div>
                    </div>
                ))}
            </div>
        );
    };

    const onTicketTypeWithoutSeatmapChange = (e, ticketTypeId) => {
        const obj = {
            ticketTypeId: ticketTypeId,
            quantity: e.target.value,
        };

        const existingTicketType = selectedTicketTypes.find(
            (t) => t.ticketTypeId === ticketTypeId
        );

        if (existingTicketType) {
            existingTicketType.quantity = e.target.value;
        } else {
            selectedTicketTypes.push(obj);
        }

        // calcualate quantity and validate
        let quantity = 0;

        selectedTicketTypes.map(s => {
            quantity += s.quantity * 1;
        });

        if (quantity > 0) {
            setDisabled(false);
        } else {
            setDisabled(true);
        }
    };

    const mapTicketTypesWithoutSeatmap = () => {
        let ticketTypesSorted = []

        if (ticketTypes && ticketTypes.length > 0) {
            ticketTypesSorted = [...ticketTypes].sort((a, b) => a.sortOrder - b.sortOrder);

            const allUnavailable = ticketTypesSorted.every(
                (tt) => tt.availability?.status !== 0
            );

            if (allUnavailable) {
                return <div>{resources.SeatmapNotAvailable}</div>;
            }
        } else {
            return null;
        }

        return (
            ticketTypes &&
            ticketTypes.length > 0 &&
            ticketTypesSorted.map((tt, index) => (
                <div key={index}>
                    {
                        (tt.availability?.status === 0) &&
                        (
                            <div className="row mt-3 mb-1">
                                <div className="col-md-8 col-5">
                                    <label className="fs-6 d-inline">
                                        {tt.info?.name}
                                    </label>
                                    {
                                        tt.info?.description && (
                                            <div className="description text-fade">
                                                <span onClick={() => setMoreInfo({ [tt.id]: !moreInfo[tt.id] })}>{resources.OtherInfos} <i className={"bi bi-chevron-" + (moreInfo[tt.id] ? "down" : "up")}></i></span><br></br>
                                                {moreInfo[tt.id] && tt.info?.description}
                                            </div>
                                        )
                                    }
                                </div>

                                <div className="col-md-1 col-2">
                                    <label>
                                        {tt.currency}
                                    </label>
                                </div>

                                <div className="col-md-1 col-2">
                                    <label>
                                        {tt.price.toFixed(2)}
                                    </label>
                                </div>

                                <div className="col-md-2 col-3 text-end">

                                    <select
                                        className="form-select form-select-tickets d-inline"
                                        onChange={(e) => onTicketTypeWithoutSeatmapChange(e, tt.id)}>
                                        {Array.from(
                                            Array(
                                                tt.availability?.availableTickets + 1
                                            ),
                                            (e, i) => {
                                                return (
                                                    <option key={i} value={i}>
                                                        {i}
                                                    </option>
                                                );
                                            }
                                        )}
                                    </select>
                                </div>

                                <hr className="ticket-separator" />
                            </div>
                        )}
                </div>
            ))
        );
    };

    const handleShowMobileBasket = () => {
        setShowMobileBasket(true);
    };

    const handleHideMobileBasket = () => {
        setShowMobileBasket(false);
    };

    return (
        <>


            <div className={`${showMobileBasket ? 'd-none d-md-block' : ''}`}>
                <Header
                    language={language}
                    pagePath="home"
                    eventId={event.id}
                    eventName={eventName}
                    eventDate={eventDate}
                    eventStartTime={eventStartTime}
                    eventCity={eventCity}
                    eventLocation={eventLocation}
                    isShoppingCartVisible={true}
                    numberOfTickets={order?.tickets?.length ?? 0}
                />

            </div>

            {loaded && !event.zoneMapId ? (
                /* Event without seatmap */
                <motion.div
                    className="page-container"
                    initial={{ opacity: 0, y: 30 }}   // start: invisible + lower
                    animate={{ opacity: 1, y: 0 }}    // end: visible + in place
                    transition={{ duration: 0.5, ease: "easeOut", delay: 0.8 }}
                >
                    <div className="container wrapper">
                        <div className="tickets-box p-4 pt-3 mt-5">
                            {mapTicketTypesWithoutSeatmap()}

                            <div className="mt-4 text-end">
                                <button
                                    className="btn btn-custom"
                                    disabled={disabled}
                                    onClick={() => onSubmit()}
                                >
                                    {resources?.Next}
                                </button>
                            </div>
                        </div>
                    </div>
                    {/* powered by */}
                    <div className="row mt-5">
                        <div className="col-md-12 text-center">
                            <p className="mt-4">
                                <small style={{ color: 'grey', fontSize: '10px' }}>powered by <a style={{ color: 'grey', textDecoration: 'none', fontSize: '13px' }} href="https://organizer.ticketino.com/de" target="_blank">TICKETINO</a></small>
                            </p>
                        </div>
                    </div>
                </motion.div>

            ) : (
                /* Event with seatnmap */
                <div className="page-container-home" style={{ backgroundColor: "#fff" }}>

                    <motion.div
                        className="container-seatmap"
                        initial={{ opacity: 0, y: 30 }}   // start: invisible + lower
                        animate={{ opacity: 1, y: 0 }}    // end: visible + in place
                        transition={{ duration: 0.5, ease: "easeOut", delay: 0.8 }}
                    >

                        <div className="row">

                            {/* left side */}
                             <div className="col-md-2">

                                {/* for mobile hide zone selector when user clicks to see the basket */}
                                <div className={`${showMobileBasket ? 'd-none d-md-block' : ''}`}>

                                    {/* zone selector */}
                                    {zones?.length > 1 &&
                                        <>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <span className="text-subtitle text-white">{resources?.SeatmapZone}</span>
                                                </div>
                                            </div>
                                            <div className="row mt-2">
                                                <div className="col col-md-12 custom-select-wrapper">
                                                    <select className="form-select form-select-zone white-arrow-select"
                                                        aria-label=""
                                                        value={selectedZone?.id ?? null}
                                                        onChange={(e) => {
                                                            let selectedZoneId = e.currentTarget.value;
                                                            if (selectedZoneId > 0) {
                                                                let zone = zones.find(z => z.id === Number(selectedZoneId));
                                                                setSelectedZone(zone);
                                                            }
                                                            else {
                                                                setSelectedZone({});
                                                            }
                                                        }}>
                                                        <option value={null} key="default" id={null}>
                                                            {resources?.SeatmapSelectZone}
                                                        </option>
                                                        {zones.map(z => (
                                                            <option key={z.id} value={z.id}>
                                                                {z.zoneName || "No name"}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                        </>
                                    }

                                    {(!selectedZone || !Object.keys(selectedZone).length > 0 || !(selectedZone.id > 0)) &&
                                        <div className="row mb-4">
                                            <div className="col ticketinoText text fs-6 text-start ticketinoError mt-2 text-center">
                                                {resources?.SeatmapPleaseSelectZone}
                                            </div>
                                        </div>
                                    }
                                    {(errorMessage) &&
                                        <div className="row mb-4">
                                            <div className="col ticketinoText text fs-6 text-start ticketinoError mt-2 text-center">
                                                errorMessage
                                            </div>
                                        </div>
                                    }
                                </div>

                                {/* ticket catetgory names and colors */}
                                {ticketTypes.length > 0 && (
                                    <div className={`${showMobileBasket ? 'd-none d-md-block' : 'mt-4'}`}>
                                        <div className="accordion" id="accordion-ticket-categories">
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="headingCoolDown">
                                                    <button
                                                        className={`accordion-button white-arrow-select ${!accordionTicketCategoryOpen ? "collapsed" : ""}`}
                                                        type="button"
                                                        onClick={() => setAccordionTicketCategoryOpen(!accordionTicketCategoryOpen)}
                                                        aria-expanded={accordionTicketCategoryOpen}
                                                        aria-controls="collapseCoolDown"
                                                    >
                                                        <label className="accordion-button-text">
                                                            {resources?.SeatmapTicketCategories}
                                                        </label>
                                                    </button>
                                                </h2>
                                                <div
                                                    id="collapseCoolDown"
                                                    className={`accordion-collapse collapse${accordionTicketCategoryOpen ? " show" : ""}`}
                                                    aria-labelledby="headingCoolDown"
                                                    data-bs-parent="#accordion-ticket-categories"
                                                >
                                                    <div className="accordion-body">
                                                        {mapTicketTypeNamesAndColors()}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* right side */}
                            <div className="col-md-10">

                                {/* seatmap */}
                                {selectedZone && Object.keys(selectedZone).length > 0 && selectedZone.id > 0 &&

                                    /* for mobile hide seatmap when user clicks to see the basket */
                                    <div className="row mb-4">
                                        <div
                                            className={`
                                                ${selectedSeats.length > 0 ? 'mt-4 col-12 col-md-9' : 'mt-4 col-12 col-md-12'}
                                                ${showMobileBasket ? 'd-none d-md-block' : ''}
                                            `}
                                        >
                                            <Zone
                                                eventId={eventId}
                                                zoneId={selectedZone.id}
                                                languageISO={language}
                                                ticketTypes={ticketTypes}
                                                selectedSeatIds={selectedSeats.length > 0 ? selectedSeats.map(seat => seat.id) : []}
                                                onSeatClick={onSeatClick}
                                            />
                                        </div>
                                        {/* shop basket panel */}
                                        {selectedSeats.length > 0 && (
                                            /* for mobile only show the shopbasket when user clicks to see the basket */
                                            <div className={`col-12 col-md-3 selectedSeatDiv mt-4 ${!showMobileBasket ? 'd-none d-md-block' : ''}`}>
                                                <div className="d-flex flex-column h-100">
                                                    <div>
                                                        {selectedSeatsDiv()}
                                                    </div>

                                                    {/* Button book tickets */}
                                                    <div className="mt-auto pt-3">
                                                        <div className="row">
                                                            <div className="col m-3">
                                                                <button
                                                                    className="btn btn-custom"
                                                                    style={{ width: "100%" }}
                                                                    disabled={
                                                                        !(selectedSeats.length > 0) ||
                                                                        selectedSeats.some(seat =>
                                                                            seat.selectedTicketTypeId === null ||
                                                                            seat.selectedTicketTypeId === "" ||
                                                                            seat.selectedTicketTypeId === 0 ||
                                                                            !('selectedTicketTypeId' in seat)
                                                                        )
                                                                    }
                                                                    onClick={() => onSubmit()}
                                                                >
                                                                    {resources?.HomeBookTickets}
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                    </div>
                                }
                            </div>
                        </div>

                        {/* for mobile sticky shopping card displayed on bottom right of the page */}
                        {selectedSeats?.length > 0 && !showMobileBasket && (
                            <div className="shopping-basket-mobile visible-mobile" onClick={() => handleShowMobileBasket()}>
                                <div className="cart-icon-wrapper">
                                    <svg
                                        fill="#000000"
                                        viewBox="-1 0 19 19"
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="cf-icon-svg"
                                    >
                                        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                                        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                                        <g id="SVGRepo_iconCarrier">
                                            <path d="M16.417 9.579A7.917 7.917 0 1 1 8.5 1.662a7.917 7.917 0 0 1 7.917 7.917zm-3.34-2.323a.63.63 0 0 0-.628-.628H5.892l-.436-1a.384.384 0 0 0-.351-.23H3.68a.384.384 0 1 0 0 .768h1.173l1.785 4.096a.37.37 0 0 0-.087-.01 1.161 1.161 0 1 0 0 2.322h.042a.792.792 0 1 0 .864 0h3.452a.792.792 0 1 0 .864 0h.565a.384.384 0 1 0 0-.767H6.55a.393.393 0 0 1 0-.787.38.38 0 0 0 .098-.013l5.803-.602a.714.714 0 0 0 .625-.694z" />
                                        </g>
                                    </svg>

                                    <span className="cart-badge">{selectedSeats.length}</span>
                                </div>
                            </div>
                        )}

                        {/* powered by */}
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <p className="mt-4">
                                    <small style={{ color: 'grey', fontSize: '10px' }}>powered by <a style={{ color: 'grey', textDecoration: 'none', fontSize: '13px' }} href="https://organizer.ticketino.com/de" target="_blank">TICKETINO</a></small>
                                </p>
                            </div>
                        </div>
                    </motion.div>
                </div >
            )}

        </>
    )
}

export default Home